import { Button } from "@components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu";
import { endpoint } from "@services/api.services";
import { METHODS } from "@services/interface.service";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import FilterPopover from "@ui/internal/components/filter-popover";
import {
  formatDate,
  formatNumber,
  showToast,
} from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { QueryMetaData } from "@utils/interface/index.interface";
import { FormFormsData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import React, { useEffect } from "react";
import { NavLink, useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import FormsForm from "./form/index.form";

type Props = {};

const index: React.FC<Props> = ({}) => {
  const pathname = usePathname();

  const { search, date } = useMetaStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, refetch, isPending, error } = useListData<
    QueryMetaData<
      FormFormsData,
      {
        total_count: number;
        categories: Record<string, number>;
      }
    >
  >({
    endpoint: endpoint["forms"],
    key: `${pathname}-listing`,
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? formatDate(date.from) : "",
      created_date__lte: date.to ? formatDate(date.to) : "",
      ordering: searchParams.get("ordering") || "order",
      is_show: searchParams.get("is_show") || "",
      is_expired: searchParams.get("is_expired") || "",
      category__name:
        searchParams.get("data-category")?.split("-")[0] === "All"
          ? ""
          : searchParams.get("data-category") || "",
    },
  });
  console.log("main data ", data);
  // rollback page
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  const { mutate } = usePostData();
  const toggleActiveStatus = (id: string | number, state: boolean) => {
    mutate(
      {
        endpoint: endpoint["forms"],

        data: {
          is_show: state,
          id,
        },
        method: METHODS.PATCH,
      },
      {
        onSuccess: () => {
          if (data) {
            const newItems = data.data.results.map((item) =>
              item.id === id ? { ...item, is_show: state } : item
            );
            console.log("new items", newItems);
            data.data.results = newItems;
            return showToast({
              title: "Visibility updated successfully",
              description: "",
              type: "success",
            });
          }
        },
        onError: () => {
          showToast({
            title: "Visibility update Failed",
            description: "",
            type: "error",
          });
        },
      }
    );
  };
  const columns = ColumnList({ toggleActiveStatus });
  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: pathname,
        }}
        isPending={isPending}
        formId={pathname}
        showOrientationSecond
        inject_ui_table_actions={
          <>
            {/* <Button variant={"outline"}>Manage Setup</Button> */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="defaultoutline">Manage Setup</Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-56" align="start">
                <DropdownMenuRadioGroup>
                  <NavLink to={"/forms/categories"}>
                    <DropdownMenuItem>Manage Categories</DropdownMenuItem>
                  </NavLink>
                </DropdownMenuRadioGroup>
              </DropdownMenuContent>
            </DropdownMenu>
            <FilterPopover
              filters={[
                {
                  label: "Expiration Status",
                  searchKey: "is_expired",
                  radio: true,
                  defaultOptions: [
                    {
                      label: "Expired",
                      value: "true",
                    },

                    {
                      label: "Not Expired",
                      value: "false",
                    },
                  ],
                },
                {
                  label: "Form Visibility",
                  searchKey: "is_show",
                  defaultOptions: [
                    {
                      label: "Shown",
                      value: "true",
                    },
                    {
                      label: "Hidden",
                      value: "false",
                    },
                  ],
                },
              ]}
              title="Filter"
              triggerText="Filter"
            />
          </>
        }
        tableHeaderData={[
          {
            id: 1,
            name: "All",
            count: formatNumber(data?.data?.total_count as number) || 0,
          },
          ...Object.keys(data?.data?.categories || {}).map((key, index) => ({
            id: index + 1,
            name: key,
            count: formatNumber(
              data?.data?.categories?.[
                key as keyof typeof data.data.categories
              ] || 0
            ),
          })),
        ]}
        sortableFilter={{
          search,
          date,
          ordering: searchParams.get("ordering") || "order",
          is_show: searchParams.get("is_show") || "",
          is_expired: searchParams.get("is_expired") || "",
        }}
        grid={
          <GeneralCard
            content={{
              title: "6 Steps to Become a Digital Marketer",
              date: "27th September, 2024 | 05:00 pm",
              tags: ["UI UX Design"],
              description:
                "Mastering the art of digital marketing is not just a valuable skill, it's a necessity whether you're an aspiring digital marketer or a business owner.",
            }}
            isChecked={false}
            type={"forms"}
            description={
              "Digital Marketing Mentorgital Marketing Mentorgital Marketing MentoDigital Marketing Mentorgital Marketing Mentorgital Marketing MentoDigital Marketing Mentorgital Marketing Mentorgital Marketing Mentor"
            }
            onDelete={() => {}}
            onEdit={() => {}}
            onToggleStatus={(id, state) => toggleActiveStatus(id, state)}
          />
        }
        columns={columns}
        endpoint={endpoint["forms"]}
        refetch={refetch}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
        form={<FormsForm />}
      />
    </>
  );
};

export default index;
